import React, { useState } from "react";
import PageLayout from "../../components/Layout/PageLayout";
import YouTubeEmbed from "../../components/elements/YouTubeEmbed";
import ModalNew from "../../components/Modal/ModalNew";

const DemoVideo: React.FC = () => {
  // States
  const [open, setOpen] = useState(false);
  const handleModalClose = () => setOpen(false);
  return (
    <PageLayout>
      <section className="relative overflow-hidden bg-gradient-to-b from-white via-white to-white md:pt-10 pt-5 pb-4">
        {/* <div className="absolute inset-0 bg-[radial-gradient(circle_at_30%_20%,rgba(0,71,255,0.1),transparent_50%)]" /> */}
        {/* <div className="absolute inset-0 bg-[radial-gradient(circle_at_70%_60%,rgba(0,174,239,0.08),transparent_50%)]" /> */}

        <div className="relative max-w-[800px] mx-auto px-3 lg:px-8">
          <div className="text-center max-w-4xl mx-auto">
            <h1 className="text-[22px] md:text-[50px] lg:text-[50px] font-bold text-gray-900 mb-3 leading-tight">
              AI Recruiter Demo Video
            </h1>

            <p className="text-sm md:text-[20px] text-gray-600 mb-2 leading-relaxed">
              Empower your hiring process with AI-powered interviews, analytics,
              and automation.
            </p>
          </div>
        </div>
        <div className="pt-3 max-w-[895px] mx-auto rounded-15 px-3">
          <div
            onClick={() => setOpen(true)}
            className="h-[300px] md:h-[505px] w-full bg-[url(/public/images/bg/demo.jpg)] bg-cover bg-center bg-no-repeat mx-auto cursor-pointer flex justify-center items-center rounded-12"
          >
            {/* <MdPlayCircleFilled size={70} className="text-[red] mt-10" /> */}
          </div>
          {/* <YouTubeEmbed
          videoId="NWmOA8Y4O_w"
          mobileHeight={350}
          desktopHeight={505}
        /> */}
          <div className="mx-auto flex justify-center pt-4">
            <audio controls>
              <source
                src="/audio/The_Million_Naira_Secret_to_AI_Recruitment__Unpacking_the_Hidde.ogg"
                type="audio/ogg"
              />
              <source
                src="/audio/The_Million_Naira_Secret_to_AI_Recruitment__Unpacking_the_Hidde.mp3"
                type="audio/mpeg"
              />
              Your browser does not support the audio element.
            </audio>
          </div>
        </div>
        <ModalNew
          isOpen={open}
          onClose={handleModalClose}
          title=""
          className="px-0 md:px-0 py-0 md:py-0 max-w-[895px]"
        >
          <YouTubeEmbed
            videoId="j4aqYvtzOz0"
            mobileHeight={350}
            desktopHeight={505}
          />
        </ModalNew>
        {/* <iframe
            width="100%"
            height="505"
            src="https://www.youtube.com/embed/NWmOA8Y4O_w"
            className="rounded-15"
          ></iframe> */}
      </section>
    </PageLayout>
  );
};

export default DemoVideo;
